var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 49,
    viewBox: "0 0 69 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.689 24.5609C43.865 24.5609 42.1483 23.5852 41.29 22.0674L34.4231 10.4671L27.449 22.0674C26.5907 23.6936 24.8739 24.6693 23.0499 24.6693C22.5135 24.6693 22.0843 24.5609 21.6551 24.4525L6.95581 20.1159V39.4136C6.95581 41.0398 8.02875 42.4492 9.53087 42.7744L32.7064 48.7372C33.7794 48.954 34.9596 48.954 36.0325 48.7372L59.2081 42.7744C60.8175 42.4492 61.8904 41.0398 61.8904 39.4136V20.1159L47.1911 24.4525C46.6547 24.5609 46.2255 24.5609 45.689 24.5609ZM68.5427 12.4185L62.9634 1.25187C62.6415 0.601386 61.9977 0.276144 61.2467 0.384558L34.4231 3.74539L44.1869 20.3327C44.6161 20.9832 45.4744 21.3085 46.2255 21.0916L67.4697 14.912C68.5427 14.5868 68.9719 13.3942 68.5427 12.4185ZM5.77558 1.25187L0.196277 12.4185C-0.2329 13.3942 0.303571 14.5868 1.26922 14.912L22.5135 21.0916C23.2645 21.3085 24.1229 20.9832 24.5521 20.2243L34.4231 3.74539L7.49228 0.384558C6.74122 0.276144 6.09746 0.601386 5.77558 1.25187Z",
    fill: "#1D2A30"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/box.a269ff70.svg";
export { ForwardRef as ReactComponent };